/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { SortableHeaderCell } from 'react-data-grid';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Edit as EditIcon,
  Help as HelpIcon,
} from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& span': {
      display: 'flex',
      alignItems: 'center',
    },
  },
}));

export default function GridColumnHeader({
  sortDirection,
  sortColumn,
  onSort,
  column,
  ...props
}) {
  const classes = useStyles();

  return (
    <SortableHeaderCell
      {...{ props }}
      column={column}
      sortColumn={sortColumn}
      onSort={onSort}
      sortDirection={sortDirection}
    >
      <span className={classes.headerContent}>
        <span>
          <span>{column.name}</span>
          {(column.tooltip) ? (
            <span>
              <Tooltip title={column.tooltip}>
                <HelpIcon color="primary" style={{ marginLeft: '5px' }} fontSize="small" />
              </Tooltip>
            </span>
          ) : ''}
        </span>
        {(column.editor) ? (
          <span>
            <EditIcon color="disabled" fontSize="small" />
          </span>
        ) : ''}
      </span>
    </SortableHeaderCell>
  );
}
